<template>
  <div class="hover-search-modal">
    <div
      :class="customClass"
      class="tw-w-full tw-bg-[#ffffff] tw-pb-[2px] tw-h-full tw-rounded-b-[6px] tw-border tw-border-solid tw-border-[#EFF0F1]"
    >
      <div
        v-if="isSearchModalAssessment"
        class="tw-flex tw-items-center tw-pb-[16px] tw-pt-[21px] tw-px-[16px] tw-cursor-pointer"
        @click="openSearchModal"
      >
        <span
          class="tw-flex tw-text-[#211F58] tw-text-[14px] tw-not-italic tw-font-[500] tw-leading-[14px]"
        >
          <div class="tw-pr-[9px] tw-cursor-pointer">
            <img src="@/assets/img/assessment_search.svg" />
          </div>
          {{
            getComponentUiText(
              "app-component-assessments-hover-search-box-assessment-title-1",
            )
          }}
        </span>
      </div>
      <div
        :class="`tw-pb-[18px] line-height-80 tw-px-[16px] ${
          isSearchModalAssessment ? '' : 'tw-pt-[21px]'
        }`"
      >
        <span class="tw-font-[400] tw-text-[11px] tw-text-[#B7B7B7]">{{
          getComponentUiText(
            "app-component-assessments-hover-search-box-assessment-recent-search-title-1",
          )
        }}</span>
      </div>
      <div
        class="tw-text-[11px] line-height-100 tw-rounded-b-[6px] tw-overflow-y-auto tw-text-[#211F58] tw-font-medium tw-px-[16px]"
      >
        <p
          v-for="item in listResentSearch"
          :key="item.id"
          class="tw-mb-[21px] tw-cursor-pointer"
          @click="(e) => onClickItemResentSearch(e)"
        >
          {{ item.searchData.text }}
        </p>
      </div>
      <div
        v-if="listResentSearch?.length > 0"
        class="tw-flex tw-items-center tw-pb-[16px] tw-px-[16px]"
      >
        <span
          class="tw-flex tw-text-[#387DFF] tw-text-[12px] tw-not-italic tw-font-[500] tw-leading-[14px] tw-cursor-pointer"
          @click="clearRecentSearch"
        >
          {{
            getComponentUiText(
              "app-component-assessments-hover-search-box-clear-search-history-1",
            )
          }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import store from "@/store";
import { getComponentUiText } from "@/utils/utilities";
import { computed } from "vue";

const emit = defineEmits(["openSearchModal", "updateCurrentValueSearch"]);

const props = defineProps({
  isSearchModalAssessment: {
    type: Boolean,
    required: false,
    default: true,
  },
  searchTypeId: {
    type: String,
    required: false,
    default: "clinput",
  },
  customClass: {
    type: String,
    required: false,
    default: "",
  },
  isVendorAssessment: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const openSearchModal = () => {
  emit("openSearchModal");
};

const listResentSearch = computed(() => {
  if (props.isVendorAssessment) return store.state.Vendor.recentSearch;
  else return store.getters["Assessment/getRecentSearch"](props.searchTypeId);
});

const clearRecentSearch = () => {
  if (props.isVendorAssessment) store.commit("Vendor/CLEAR_RECENT_SEARCH");
  else {
    store.dispatch("Assessment/clearRecentSearch", {
      searchTypeId: props.searchTypeId,
    });
  }
};

const onClickItemResentSearch = (e: any) => {
  emit("updateCurrentValueSearch", e.target.innerText);
};
</script>
